import { createApi } from "@reduxjs/toolkit/query/react";
import authBaseQuery from "../../../../utils/authBaseQuery";

const PurchaseRequestPaymentApi = createApi({
  reducerPath: "PurchaseRequestPaymentApi",
  baseQuery: authBaseQuery,
  endpoints: (builder) => ({
    // Add a new vendor payment request
    addPurchase: builder.mutation({
      query: (formData) => ({
        url: "v1/vendor_payment_request",
        method: "POST",
        body: formData,
      }),
      onQueryStarted: async (formData, { dispatch, queryFulfilled }) => {
        try {
          const { data: addedPurchase } = await queryFulfilled;

          if (addedPurchase && addedPurchase.data) {
            // // console.log("Purchase added successfully:", addedPurchase.data);
          }
        } catch (error) {
          console.error("Failed to add purchase:", error);
        }
      },
    }),
    // Add a new vendor payment request
    addPurchaseLinkWise: builder.mutation({
      query: (formData) => ({
        url: "v1/vendor_payment_request_link_wise",
        method: "POST",
        body: formData,
      }),
      onQueryStarted: async (formData, { dispatch, queryFulfilled }) => {
        try {
          const { data: addedPurchase } = await queryFulfilled;

          if (addedPurchase && addedPurchase.data) {
            // // console.log("Purchase added successfully:", addedPurchase.data);
          }
        } catch (error) {
          console.error("Failed to add purchase:", error);
        }
      },
    }),
    // Fetch vendor payment transactions
    getVendorPaymentTransactions: builder.query({
      query: ({ startDate, endDate }) => {
        return `v1/vendor_payment_transactions?startDate=${startDate}&endDate=${endDate}`;
      },
      transformResponse: (response) =>
        response.data.filter((item) => item.payment_mode != "advanced-settled"), // Optional: transform the response
    }),
    getPaymentRequestTransactions: builder.query({
      query: ({ request_id }) => {
        return `v1/vendor_payment_transactions?requestId=${request_id}`;
      },
      transformResponse: (response) => response.data, // Optional: transform the response
    }),
    // getVendorPaymentRequests: builder.query({
    //   query: (status) => {
    //     return `v1/vendor_payment_request?${status}`;
    //   },

    //   transformResponse: (response) => response.data, // Optional: transform the response
    // }),

    getVendorPaymentRequests: builder.query({
      query: ({ status, search, limit, page }) => {
        let query = status || "";
        if (limit && page) {
          query += `${query ? "&" : ""}page=${page}&limit=${limit}`
        }
        if (search && `${search}`?.trim() !== "") {
          query += `${query ? "&" : ""}search=${encodeURIComponent(
            `${search}`?.trim()
          )}`;
        }

        return `v1/vendor_payment_request?${query}`;
      },

      transformResponse: (response) => {
        return response
      },
    }),

    getVendorFinancialDetail: builder.query({
      query: (_id) => {
        return `v1/vendor_wise_financials_details/${_id}`;
      },
      transformResponse: (response) => response.data, // Optional: transform the response
    }),
    // get vendor recent Invoices detail
    getVendorRecentInvoicesDetail: builder.query({
      query: (_id) => {
        return `v1/get_vendor_recent_invoice/${_id}`;
      },
      transformResponse: (response) => response.data, // Optional: transform the response
    }),
    // Update a vendor payment request
    updatePurchaseRequest: builder.mutation({
      query: ({ _id, formData }) => ({
        url: `v1/vendor_payment_request/${_id}`,
        method: "PUT",
        body: formData,
      }),
      onQueryStarted: async (
        { id, formData },
        { dispatch, queryFulfilled }
      ) => {
        try {
          const { data: updatedPurchase } = await queryFulfilled;
          if (updatedPurchase && updatedPurchase.data) {
            // // console.log("Purchase updated successfully:", updatedPurchase.data);
          }
        } catch (error) {
          console.error("Failed to update purchase:", error);
        }
      },
    }),
    // Delete a vendor payment request
    deletePurchaseRequest: builder.mutation({
      query: (_id) => ({
        url: `v1/vendor_payment_request/${_id}`,
        method: "DELETE",
      }),
      onQueryStarted: async (_id, { dispatch, queryFulfilled }) => {
        try {
          const { data: deletedPurchase } = await queryFulfilled;
          if (deletedPurchase && deletedPurchase.success) {
            // // console.log("Purchase request deleted successfully:", _id);
          }
        } catch (error) {
          console.error("Failed to delete purchase request:", error);
        }
      },
    }),

    // Fetch advanced payment details
    getAdvancedPayment: builder.query({
      query: (vendorObjId) => {
        return `purchase/advanced_payment/${vendorObjId}`;
      },
      transformResponse: (response) => response.data, // Optional: transform the response
    }),
    // Advanced Payment Settlement
    advancedPaymentSettlement: builder.mutation({
      query: ({ settlementData, vendorObjId }) => ({
        url: `purchase/advanced_payment_settlement/${vendorObjId}`,
        method: "PUT",
        body: settlementData,
      }),
      onQueryStarted: async (settlementData, { dispatch, queryFulfilled }) => {
        try {
          const { data: settlementResponse } = await queryFulfilled;
          if (settlementResponse && settlementResponse.data) {
            // // console.log("Advanced payment settled successfully:", settlementResponse.data);
          }
        } catch (error) {
          console.error("Failed to settle advanced payment:", error);
        }
      },
    }),
    // Fetch advanced payment details
    getCreativefuelOutstandingZero: builder.query({
      query: () => {
        return `v1/creativefuel_settlement_purchase_outstanding`;
      },
      transformResponse: (response) => response.data, // Optional: transform the response
    }),
  }),
});
// ?vendorId=${vendorId}&page=${page}&limit=${limit}
export const {
  useAddPurchaseMutation,
  useAddPurchaseLinkWiseMutation,
  useGetVendorPaymentTransactionsQuery,
  useGetVendorPaymentRequestsQuery,
  useGetPaymentRequestTransactionsQuery,
  useGetVendorFinancialDetailQuery,
  // getVendorRecentInvoicesDetail
  useGetVendorRecentInvoicesDetailQuery,
  useUpdatePurchaseRequestMutation,
  useDeletePurchaseRequestMutation,
  useGetAdvancedPaymentQuery,
  useAdvancedPaymentSettlementMutation,
  useLazyGetCreativefuelOutstandingZeroQuery,
} = PurchaseRequestPaymentApi;

export default PurchaseRequestPaymentApi;
